import actions from '@/core/store/item-pedido/estorno/detalhes-estorno/actions'

export default { actions }
